// Slider.js
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "./Slider.css"; // your custom overlay styles

const Slider = () => {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://immaculatenursingkkl.org/iihs/api/get_slider.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.data.length > 0) {
          const formattedSlides = data.data.map((slide) => ({
            image: slide.image_url,
            titleSmall: slide.title || "",      // from DB 'title'
            titleLarge: slide.subtitle || "",  // from DB 'subtitle'
          }));
          setSlides(formattedSlides);
        } else {
          // Fallback slide if DB is empty
          setSlides([
            {
              image: "/images/banner/1.jpg",
              titleSmall: "Welcome To",
              titleLarge: "Immaculate Institute Of Health Sciences",
            },
          ]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching slider:", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading slider...</div>;
  }

  return (
    <div className="slider-wrapper">
      <Swiper
        modules={[Autoplay, Pagination, EffectFade]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        effect="fade"
        pagination={{ clickable: true }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="slide"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="overlay">
                <h3 className="slide-title-small">{slide.titleSmall}</h3>
                <h1 className="slide-title-large">{slide.titleLarge}</h1>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Slider;
